import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import translationKeys from 'translations/translationKeys';

const CurrencySelector = ({
  secondaryCurrencyConfigs,
  targetCurrency,
  onChange,
  variant,
  id,
}) => {
  const { t } = useTranslation();
  const { msg278 } = translationKeys;

  useEffect(() => {
    if (!targetCurrency && secondaryCurrencyConfigs?.length > 0) {
      const firstCurrency = secondaryCurrencyConfigs[0].strCode;
      if (firstCurrency) {
        onChange(firstCurrency);
      }
    }
  }, [targetCurrency, secondaryCurrencyConfigs, onChange]);

  if (!secondaryCurrencyConfigs?.length) return null;

  return (
    <div className={`currency-selector currency-selector--${variant}`}>
      <label htmlFor={id} className="currency-selector__label">
        {t(msg278)}
      </label>
      <select
        id={id}
        className="currency-selector__select"
        value={targetCurrency || ''}
        onChange={(e) => onChange(e.target.value || null)}
      >
        <option value="">—</option>
        {secondaryCurrencyConfigs.map((cfg) => (
          <option key={cfg.strCode} value={cfg.strCode}>
            {cfg.strCode}
          </option>
        ))}
      </select>
    </div>
  );
};

CurrencySelector.propTypes = {
  secondaryCurrencyConfigs: PropTypes.arrayOf(
    PropTypes.shape({
      lgCurrencyID: PropTypes.string,
      strCode: PropTypes.string,
      strDescription: PropTypes.string,
      strStatut: PropTypes.string,
      bDefault: PropTypes.bool,
      strGroupingSeparator: PropTypes.string,
      strDecimalSeparator: PropTypes.string,
      strDisplayFormat: PropTypes.string,
      bCodeAppendedEnd: PropTypes.bool,
      bAddCodeValueSeparator: PropTypes.bool,
      strCodeValueSeparator: PropTypes.string,
      intFractionsCount: PropTypes.number,
      dtCreated: PropTypes.shape({
        seconds: PropTypes.number,
        nanos: PropTypes.number,
      }),
    }),
  ).isRequired,
  targetCurrency: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['header', 'inline']),
  id: PropTypes.string,
};

CurrencySelector.defaultProps = {
  targetCurrency: null,
  variant: 'header',
  id: 'currency-selector',
};

export default CurrencySelector;
